import React, { useState, useEffect, Fragment } from 'react';
import ClientHeaderCostaneraNorte from './HeaderCostaneraNorte';
import ClientHeaderVespucioSur from './HeaderVespucioSur';
import ClientHeaderVespucioNorte from './HeaderVespucioNorte';
import ClientHeaderClaroVentas from './HeaderClaroVentas';
import ClientHeaderFalabella from './headerFalabella';
import ClientHeaderBcoChile from './HeaderBcoChile';
import ClientCaja18 from './HeaderCaja18';
import ClientHeaderENRCN from './HeaderENRCN'; //ENROLAMEINTO CN
import ClientHeaderENRVS from './HeaderENRVS';//ENROLAMEINTO VS
import ClientHeaderJunglabet from './HeaderJunglabet'
import ClientHeaderClaroMora from './HeaderClaroMora'
import ClientHeaderClaroCastigo from './HeaderClaroCastigo'
import ClientHeaderClaroPreventiva from './HeaderClaroPreventiva'
import ClientHeaderForum from './HeaderForum'
import ClientHeaderTanner from './HeaderTanner'
import ClientHeaderRipley from './HeaderRipley'
import ClientHeaderAIEP from './HeaderAIEP'
import ClientHeaderAraucana from './HeaderAraucana'
import ClientHeaderNuestrosParques from './HeaderNuestrosParques'
import ClientHeaderClaroDicom from './HeaderClaroDicom'
import ClientHeaderVtr from './HeaderVtr'
import ClientHeaderFamilyCastigo from './HeaderFamilyCastigo'
import ClientHeaderCepech from './HeaderCepech'

const ClientHeader = (props) => {

    

    useEffect(() => {
        //onload execute ....
    }, []);

    let companyId=props.campaign.company_info._id;

    return (
        <Fragment>
            {companyId === 100 ? ( //COSTANERA NORTE
                <ClientHeaderCostaneraNorte campaign={props.campaign} client={props.client} phone={props.phone} updateClientMethod={props.updateClientMethod}/>
            ) : companyId === 103 ? ( //VESPUCIO SUR
                <ClientHeaderVespucioSur campaign={props.campaign} client={props.client} phone={props.phone} updateClientMethod={props.updateClientMethod}/>
            ) : companyId === 101 ? ( //BCOCHILE
                <ClientHeaderBcoChile campaign={props.campaign} client={props.client} phone={props.phone} updateClientMethod={props.updateClientMethod} />
            ) : companyId === 150 ? ( //CAJA 18
                <ClientCaja18 campaign={props.campaign} client={props.client} phone={props.phone} updateClientMethod={props.updateClientMethod} />
            ) : companyId === 200 ? ( //FALABELLA
                <ClientHeaderFalabella campaign={props.campaign} client={props.client} phone={props.phone} updateClientMethod={props.updateClientMethod} />
            ) : companyId === 106 ? ( //VESPUCIO NORTE
                <ClientHeaderVespucioNorte campaign={props.campaign} client={props.client} phone={props.phone} updateClientMethod={props.updateClientMethod}/>
            ) : companyId === 111 ? ( //CLAROVENTAS
                <ClientHeaderClaroVentas campaign={props.campaign} client={props.client} phone={props.phone} updateClientMethod={props.updateClientMethod} />
            ) : companyId === 112 ? ( //ENROLAMIENTO COSTANERA NORTE
                <ClientHeaderENRCN campaign={props.campaign} client={props.client} phone={props.phone} updateClientMethod={props.updateClientMethod} />
            ) : companyId === 113 ? ( //ENROLAMIENTO VESPUCIO SUR
                <ClientHeaderENRVS campaign={props.campaign} client={props.client} phone={props.phone} updateClientMethod={props.updateClientMethod} />
            ) : companyId === 114 ? ( //JUNGLABET
                <ClientHeaderJunglabet campaign={props.campaign} client={props.client} phone={props.phone} updateClientMethod={props.updateClientMethod} />
            ) : companyId === 107 ? ( //CLARO_MORA
                <ClientHeaderClaroMora campaign={props.campaign} client={props.client} phone={props.phone} updateClientMethod={props.updateClientMethod} />
            ) : companyId === 108 ? ( //CLARO_CASTIGO
                <ClientHeaderClaroCastigo campaign={props.campaign} client={props.client} phone={props.phone} updateClientMethod={props.updateClientMethod} />
            ) : companyId === 109 ? ( //CLARO_PREVENTIVA
                <ClientHeaderClaroPreventiva campaign={props.campaign} client={props.client} phone={props.phone} updateClientMethod={props.updateClientMethod} />
            ) : companyId === 116 || companyId === 117 ? ( //FORUM (preventiva y mora)
                <ClientHeaderForum campaign={props.campaign} client={props.client} phone={props.phone} updateClientMethod={props.updateClientMethod} />
            ) : companyId === 119 ? ( //TANNER
                <ClientHeaderTanner campaign={props.campaign} client={props.client} phone={props.phone} updateClientMethod={props.updateClientMethod} />
            ) : companyId === 120 ? ( //RIPLEY
                <ClientHeaderRipley campaign={props.campaign} client={props.client} phone={props.phone} updateClientMethod={props.updateClientMethod} />
            ) : companyId === 121 || companyId === 122 ? ( //AIEP, CPECH )
                <ClientHeaderAIEP campaign={props.campaign} client={props.client} phone={props.phone} updateClientMethod={props.updateClientMethod} />
            ) : companyId === 123 ? ( //LA ARAUCANA
                <ClientHeaderAraucana campaign={props.campaign} client={props.client} phone={props.phone} updateClientMethod={props.updateClientMethod} />
            ) : companyId === 124 ? ( //NUESTROS PARQUES
                <ClientHeaderNuestrosParques campaign={props.campaign} client={props.client} phone={props.phone} updateClientMethod={props.updateClientMethod} />
            ) : companyId === 125 ? ( //CLARO DICOM
                <ClientHeaderClaroDicom campaign={props.campaign} client={props.client} phone={props.phone} updateClientMethod={props.updateClientMethod} />
            ) : companyId === 126 ? ( //VTR
                <ClientHeaderVtr campaign={props.campaign} client={props.client} phone={props.phone} updateClientMethod={props.updateClientMethod} />
            ) : companyId === 127 ? ( //Family Castigo
                <ClientHeaderFamilyCastigo campaign={props.campaign} client={props.client} phone={props.phone} updateClientMethod={props.updateClientMethod} />
            ) : companyId === 128 ? ( //CEPECH
                <ClientHeaderCepech campaign={props.campaign} client={props.client} phone={props.phone} updateClientMethod={props.updateClientMethod} />
            ) : null}

        </Fragment>
    );

}

export default ClientHeader;
